module.exports = __webpack_public_path__ + "img/goal_blue.b601b56b.svg";